<template>
  <div class="sticky top-0 z-10">
    <TopNav :pageScrolled='true'/>
  </div>
  <MainNav/>
  <div class="sticky">
    <h1>This is an about page</h1>
  </div>
  <p>
    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ut facere ipsa earum reprehenderit rem minima ullam, aspernatur id? Facere sapiente dignissimos itaque consequatur doloribus reiciendis exercitationem quae voluptatum ab in?
    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ut facere ipsa earum reprehenderit rem minima ullam, aspernatur id? Facere sapiente dignissimos itaque consequatur doloribus reiciendis exercitationem quae voluptatum ab in?
    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ut facere ipsa earum reprehenderit rem minima ullam, aspernatur id? Facere sapiente dignissimos itaque consequatur doloribus reiciendis exercitationem quae voluptatum ab in?
    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ut facere ipsa earum reprehenderit rem minima ullam, aspernatur id? Facere sapiente dignissimos itaque consequatur doloribus reiciendis exercitationem quae voluptatum ab in?
    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ut facere ipsa earum reprehenderit rem minima ullam, aspernatur id? Facere sapiente dignissimos itaque consequatur doloribus reiciendis exercitationem quae voluptatum ab in?
    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ut facere ipsa earum reprehenderit rem minima ullam, aspernatur id? Facere sapiente dignissimos itaque consequatur doloribus reiciendis exercitationem quae voluptatum ab in?
    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ut facere ipsa earum reprehenderit rem minima ullam, aspernatur id? Facere sapiente dignissimos itaque consequatur doloribus reiciendis exercitationem quae voluptatum ab in?
    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ut facere ipsa earum reprehenderit rem minima ullam, aspernatur id? Facere sapiente dignissimos itaque consequatur doloribus reiciendis exercitationem quae voluptatum ab in?
    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ut facere ipsa earum reprehenderit rem minima ullam, aspernatur id? Facere sapiente dignissimos itaque consequatur doloribus reiciendis exercitationem quae voluptatum ab in?
    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ut facere ipsa earum reprehenderit rem minima ullam, aspernatur id? Facere sapiente dignissimos itaque consequatur doloribus reiciendis exercitationem quae voluptatum ab in?
  </p>
</template>


<script>
import TopNav from '../components/TopNav'
import MainNav from '../components/MainNav'
export default {
  name: 'Discover',
  components: {
    TopNav,
    MainNav,
  }
}
</script>